"use strict";

import richtext from "dias/core/richtext";
import foerdermoduleRegistry from "dias/foerderantrag/foerdermodule";
import parameter from "./parameter";

import "angular-input-masks";

const dynamische_tabelle = angular.module("dias.standard_foerdermodule.dynamische_tabelle", [
  "ui.utils.masks",
  richtext.name,
  foerdermoduleRegistry.name,
  parameter.name,
]);

export default dynamische_tabelle;
